import { render, staticRenderFns } from "./NationalTrademarkHistoryList.vue?vue&type=template&id=c51ab2f4&"
import script from "./NationalTrademarkHistoryList.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkHistoryList.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkHistoryList.vue?vue&type=style&index=0&id=c51ab2f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports